import React, { useRef } from "react";
import { Helmet } from "react-helmet-async";

import Config from "../Config.json";
import { Link, useNavigate } from "react-router-dom";

const TITLE = "DBC | " + Config.SITE_TITLE;
const DESC = "Create a React App from an HTML Website.";
const CANONICAL = Config.SITE_DOMAIN + "/";

const CookiePolicy = () => {
  return (
    <main className="contact-main-content ">
      <Helmet>
        <title>Cookie Policy</title>
        <link rel="canonical" href={CANONICAL}></link>
        <meta name="description" content={DESC} />
        <meta name="theme-color" content={Config.THEME_COLOR} />
      </Helmet>
      <div className="w-100">
        <div className="contact-container">
          <h1 className="contact py-3 ps-3">Cookie Policy</h1>
        </div>
        <div className="contact-content-container w-75">
          <h2 className="contact-color contact-margin-y">Cookie Policy</h2>
          <h5>
            <strong>Last updated:</strong> May 3, 2025
          </h5>
          <p>
            This Cookie Policy explains how our website uses cookies and similar
            technologies to enhance your experience. By using our site, you
            consent to the use of cookies as described in this policy.
          </p>

          <h2 className="contact-color contact-margin-y2">What Are Cookies?</h2>
          <p>
            Cookies are small text files stored on your device by your web
            browser. They help websites recognize your device and remember
            information about your visit, such as your preferences or login
            status.
          </p>

          <h2 className="contact-color contact-margin-y2">
            Types of Cookies We Use
          </h2>
          <ul>
            <li>
              <strong>Essential Cookies:</strong> These cookies are necessary
              for the basic operation of the website. They allow you to navigate
              the site and use core features like page navigation and access to
              secure areas.
            </li>

            <li>
              <strong>Functional Cookies:</strong> These cookies enable the
              website to remember choices you make (such as language preferences
              or region) and provide enhanced, more personalized features.
            </li>

            <li>
              <strong>Analytics Cookies:</strong> These cookies collect
              information about how visitors use the website (e.g., which pages
              are most visited). This helps us improve the way our website
              works. We use tools like Google Analytics to gather this data, but
              all data is anonymized.
            </li>

            <li>
              <strong>Session Cookies:</strong> These are temporary cookies that
              expire once you close your browser. They help us recognize you
              during a single session on the website.
            </li>
          </ul>

          <h2 className="contact-color contact-margin-y2">
            Third-Party Cookies
          </h2>
          <p>
            In some cases, we use cookies provided by trusted third parties. For
            example, analytics services such as Google Analytics may set cookies
            to track usage statistics. These cookies are subject to the privacy
            policies of the respective providers.
          </p>

          <h2 className="contact-color contact-margin-y2">Your Choices</h2>
          <p>
            You can choose to accept or decline cookies. Most browsers
            automatically accept cookies, but you can usually modify your
            browser settings to decline cookies if you prefer. Be aware that
            disabling cookies may affect the functionality of this and other
            websites you visit.
          </p>

          <h2 className="contact-color contact-margin-y2">
            How to Manage or Delete Cookies
          </h2>
          <p>
            To manage or delete cookies, you can follow the instructions for
            your browser:
          </p>
          <ul>
            <li>
              <a
                href="https://support.google.com/chrome/answer/95647"
                target="_blank"
              >
                Google Chrome
              </a>
            </li>
            <li>
              <a
                href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox"
                target="_blank"
              >
                Mozilla Firefox
              </a>
            </li>
            <li>
              <a
                href="https://support.apple.com/en-us/HT201265"
                target="_blank"
              >
                Safari
              </a>
            </li>
            <li>
              <a
                href="https://support.microsoft.com/en-us/topic/how-to-delete-cookie-files-in-internet-explorer-bca9446f-d873-78de-77ba-d42645fa52fc"
                target="_blank"
              >
                Internet Explorer / Edge
              </a>
            </li>
          </ul>
          <h2 className="contact-color contact-margin-y2">
            Changes to This Policy
          </h2>
          <p>
            We may update this Cookie Policy from time to time. Any changes will
            be posted on this page and will take effect immediately upon
            publication.
          </p>

          <h2 className="contact-color contact-margin-y2">Contact</h2>
          <p>
            If you have any questions about these terms, please contact us at:{" "}
            <a href="mailto:info@aiinsidelife.com">info@AiinsideLife.com</a>
          </p>
        </div>
      </div>
    </main>
  );
};

export default CookiePolicy;
